export default {
  "home.heading.default": "上麦聊聊",
  "home.heading.loading": "正在准备房间...",
  "home.heading.join": "准备进房？",
  "home.heading.joined": "进来了",
  "home.heading.pending": "等房主放人",
  "home.body.default": "建个房，丢个链接，开聊。",
  "home.body.loading": "等一下，马上建好。",
  "home.body.join": "检查下镜头和麦，然后直接进。",
  "home.body.joined": "房间已开。发链接摇人，或者直接开聊。",
  "home.body.joined_in_room": "已经在房间里了——直接聊或者发链接摇人。",
  "home.body.pending": "房间锁了，等房主放你进去。",
  "home.cta.create": "建个房间",
  "home.cta.join": "进房间",
  "home.cta.enter": "进去",
  "home.cta.creating": "正在建...",
  "home.cta.joining": "正在进...",
  "home.cta.opening": "正在开...",
  "home.cta.pending": "等房主放行...",
  "home.copy_link": "复制链接",
  "home.copied": "复制啦！",
  "home.leave": "离开房间",
  "home.back": "返回",
  "home.no_participants": "还没人来",
  "home.join_by_code": "用邀请码进",
  "home.code_placeholder": "填邀请码",
  "home.name_placeholder": "怎么称呼",
  "home.people_one": "人",
  "home.people_other": "人",
  "home.marketing.invite.title": "建个房间，\n分享链接。",
  "home.marketing.invite.body": "一键开播。把链接发给朋友，谁都能进——免下载，免注册。",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "想要什么画风，\n自己定。",
  "home.marketing.look.body": "调色、柔光、暗角——或者干脆把脸糊掉。你的镜头，你说了算。",
  "home.marketing.host.title": "你的地盘，\n听你的。",
  "home.marketing.host.body": "锁房、闭麦，或者直接踢人。房主绝对控场。",
  "home.marketing.host.locked": "房间已锁",
  "home.marketing.host.waiting_to_join": "等待进入",
  "home.marketing.host.wants_to_join": "想进来",
  "home.marketing.anything.title": "真的，干啥都行。",
  "home.marketing.anything.body": "一起自习、开黑、工作站会、看片——或者单纯挂着闲聊。",
  "home.marketing.use_case.study_group": "📚 组团自习",
  "home.marketing.use_case.game_night": "🎮 熬夜开黑",
  "home.marketing.use_case.standup": "💼 每日站会",
  "home.marketing.use_case.watch_party": "🍿 一起看片",
  "home.marketing.use_case.catch_up": "☕ 闲聊叙旧",
  "home.marketing.use_case.jam_session": "🎸 线上玩乐器",
  "home.marketing.use_case.book_club": "📖 读书会",
  "home.marketing.use_case.coworking": "💻 云办公",
  "ended.heading": "聊完了",
  "ended.left": "你已退出房间。",
  "ended.room_ended": "{title} 已经结束啦。",
  "ended.rejoin": "重新进",
  "ended.rejoining": "正在重新进...",
  "ended.home": "回首页",
  "call.connecting": "连接中",
  "call.waiting": "等其他人来",
  "call.invite_code": "邀请码",
  "call.audio_on": "麦开着",
  "call.muted": "已闭麦",
  "call.listening": "旁听中",
  "call.audio_muted": "没开麦",
  "call.speaking": "正在说话",
  "call.you": "你",
  "call.you_label": "你",
  "call.you_suffix": "(你)",
  "call.chat_placeholder": "随便说点啥...",
  "call.guest": "访客",
  "call.room_fallback": "房间",
  "call.focus_view": "沉浸模式",
  "call.grid_view": "网格模式",
  "call.swap_main_video": "切换主画面",
  "call.open_chat": "打开聊天",
  "call.close_chat": "关掉聊天",
  "call.leave_room": "离开房间",
  "call.confirm_leave": "真要走？",
  "call.mic_on": "麦克风开",
  "call.muted_label": "已闭麦",
  "call.camera_off": "镜头关",
  "call.connect_failed": "连不上——检查下网再试试。",
  "call.camera_access_failed": "打不开镜头。检查下浏览器权限再试试。",
  "call.recording_failed": "录制没开起来，不过聊天继续。",
  "call.initialize_failed": "开启失败了，刷新一下试试。",
  "call.participants": "房间里的人",
  "call.open_participants": "查看所有人",
  "call.close_participants": "收起列表",
  "call.lock_room": "锁门",
  "call.unlock_room": "开门",
  "call.locked": "已锁",
  "call.unlocked": "开放中",
  "call.kick_member": "踢出房间",
  "call.mute_member": "闭麦",
  "call.unmute_member": "解除闭麦",
  "call.muted_by_host": "被房主闭麦了",
  "call.waiting_to_join": "等着进呢",
  "call.approve": "放行",
  "call.deny": "拒绝",
  "call.profile_actions": "资料操作",
  "call.profile_in_room": "在房间里",
  "call.profile_role_host": "房主",
  "call.profile_role_you": "你",
  "call.profile_action_mute": "屏蔽TA的声音",
  "call.profile_action_mute_meta": "只有你听不到——TA不会知道的",
  "call.profile_action_dm": "私聊",
  "call.profile_action_dm_meta": "开个私密小窗",
  "call.profile_action_view": "看完整资料",
  "call.profile_action_view_meta": "简介、语言、历史记录",
  "call.profile_action_report": "举报",
  "call.profile_action_report_meta": "提交给管理员审核",
  "call.profile_sheet_close": "关闭操作",
  "call.profile_open_actions": "打开操作",
  "call.dm_title": "私聊",
  "call.dm_back": "返回",
  "call.dm_close": "关掉私聊",
  "call.dm_status_online": "在线",
  "call.dm_in_room_with": "在同一个房间",
  "call.dm_private_label": "私密聊天",
  "call.dm_private_meta": "只有你俩能看到",
  "call.dm_input_placeholder": "发私信…",
  "call.dm_send": "发送",
  "call.dm_just_now": "刚刚",
  "call.dm_seen_just_now": "刚刚已读",
  "call.dm_typing": "{name} 正在输入…",
  "call.dm_minimize": "最小化",
  "call.dm_active_indicator": "打开聊天",
  "call.dm_unread_messages": "{count} 条未读",
  "call.dm_toast_tap_to_open": "点开看看",
  "call.dm_reopen_aria": "重新打开和 {name} 的聊天",
  "home.join_denied": "房主没让你进。",
  "home.error.room_not_found": "房间码不存在。",
  "home.error.profile_required": "先搞定个人资料再继续。",
  "home.cta.set_up_profile": "设置个人资料",
  "home.profile_trigger_new": "点这里添加资料",
  "home.profile_trigger_new_aria": "设置个人资料",
  "home.profile_trigger_edit_aria": "修改资料",
  "profile.eyebrow_new": "打个招呼",
  "profile.eyebrow_edit": "你的资料",
  "profile.title_new": "打造你的专属名片。",
  "profile.title_edit": "修改资料",
  "profile.subtitle": "随便填点啥，让大家认识认识你。",
  "profile.add_photo": "加张照片",
  "profile.add_photo_soon": "照片功能马上就来",
  "profile.photo_empty": "点这里加照片",
  "profile.photo_ready": "照片搞定",
  "profile.photo_save_first": "传照片前先保存资料哦",
  "profile.photo_crop_caption": "调整一下位置",
  "profile.photo_auto_caption": "拖拽缩放，我们会自动保存",
  "profile.photo_upload": "上传照片",
  "profile.photo_replace": "换张照片",
  "profile.photo_remove": "删掉照片",
  "profile.photo_cancel": "取消",
  "profile.photo_save": "保存照片",
  "profile.photo_uploading": "正在传照片…",
  "profile.photo_removing": "正在删照片…",
  "profile.photo_choose_another": "换一张",
  "profile.photo_drag_hint": "把照片拖进圈里，会自动保存。",
  "profile.photo_zoom": "缩放",
  "profile.photo_horizontal": "水平裁剪",
  "profile.photo_vertical": "垂直裁剪",
  "profile.name_label": "名字",
  "profile.name_placeholder": "怎么称呼你？",
  "profile.gender_label": "我是",
  "profile.gender.woman": "女生",
  "profile.gender.man": "男生",
  "profile.gender.unspecified": "保密",
  "profile.bio_label": "简介",
  "profile.bio_optional": "选填",
  "profile.bio_placeholder": "会啥语言、喜欢啥，随便写点…",
  "profile.cta_new": "走起",
  "profile.cta_edit": "保存修改",
  "profile.saving": "保存中…",
  "profile.close": "关闭",
  "profile.error.save_failed": "资料没存上，再试一次。",
  "profile.error.avatar_invalid_type": "选个 PNG、JPEG、GIF 或 WebP 格式的图呗。",
  "profile.error.avatar_too_large": "图片得小于 5 MB 哦。",
  "profile.error.avatar_too_small": "图片至少得 96x96 像素。",
  "profile.error.avatar_load_failed": "图片读不出来，换一张试试。",
  "profile.error.avatar_failed": "照片没传上去，再试一次。",
  "profile.error.avatar_remove_failed": "照片没删掉，再试一次。",
  "effects.title": "特效",
  "effects.soft": "柔光",
  "effects.vignette": "暗角",
  "effects.face": "脸部打码",
  "effects.face_preview_only": "脸部打码（仅预览）",
  "effects.face_viewer_side": "脸部打码（观众可见）",
  "effects.face_strength": "打码强度",
  "effects.grade.off": "关",
  "effects.grade.pop": "鲜艳",
  "effects.grade.warm": "暖色",
  "effects.grade.cool": "冷色",
  "effects.grade.bw": "黑白",
  "camera.off": "镜头关着呢",
  "camera.check": "检查下镜头",
  "camera.retry": "重试镜头",
  "camera.ready": "镜头搞定",
  "camera.idle.title": "打开镜头",
  "camera.idle.hint": "准备好后，我们会向浏览器申请权限。",
  "camera.idle.button": "开启镜头",
  "camera.status.idle": "等你呢",
  "camera.status.off": "镜头关着",
  "camera.status.loading": "正在申请镜头权限...",
  "camera.status.denied": "在浏览器里给下镜头权限，然后再试。",
  "camera.status.error": "镜头预览失败了，再试一次。",
  "camera.status.unsupported": "这个浏览器不支持开镜头。",
  "camera.status.insecure": "开镜头需要 HTTPS 或 localhost 环境。",
  "camera.status.attach_failed": "镜头预览没开起来，再试一次。",
  "camera.guest_name_placeholder": "访客名字",
  "camera.flip": "翻转镜头",
  "camera.save_name": "保存",
  "camera.edit_name": "改名",
  "mic.on": "关麦",
  "mic.off": "开麦",
  "video.on": "关镜头",
  "video.off": "开镜头",
  "chat.title": "聊天",
  "chat.close": "关掉聊天",
  "chat.loading": "加载中...",
  "chat.load_earlier": "看之前的",
  "chat.empty": "还没人说话",
  "chat.send_error": "消息没发出去——再试一次。",
  "chat.input_placeholder": "随便说点啥...",
  "room.host": "房主",
  "app.room_default_title": "建个房间",
  "app.chat_connection_rejected": "聊天连不上——刷新试试。",
  "app.copy_failed": "链接没复制成功，试着手动选一下复制吧。",
  "app.chat_not_connected": "聊天还没连上，等会儿再试。",
  "footer.terms": "条款与条件",
  "footer.copyright": "© 2026 Yano.AI"
}
